import { DSPostShort } from 'shared-definitions/types'
import { nullableString, nullableNumber } from 'shared-code/conversion'
import { ApiPostShortProps } from 'data-source/types.wp'
import { categoryTextMapper } from 'data-source/mappers/categoryTextMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { sponsorInfoMapper } from 'data-source/mappers/sponsorInfoMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'

export function onePostMapper(input: ApiPostShortProps, opts: PLinkMapperOpts): DSPostShort {
  return {
    ...sponsorInfoMapper(input),
    badge: input.badge ? imageMapper(input.badge, opts) : null,
    pLink: opts.postLinkBuilder(input.slug),
    title: input.title,
    excerpt: nullableString(input.excerpt),
    date: input.date,
    score: nullableNumber(input.score),
    image: imageMapper(input.image, opts),
    category: categoryTextMapper(input.category),
    engagementContainerId: input.engagement_container_id ?? null,
  }
}
